/**
 * Workspace Creation Conversion Tracking
 * 
 * Tracks the conversion funnel:
 * 1. Form submitted (count attempts before auth)
 * 2. Workspace created (with workspace_id)
 * 3. Workspace sent to review - CONVERSION! (with workspace_id)
 * 
 * Google Analytics/GTM can track:
 * - How many form submissions before auth
 * - Conversion rate from workspace_created → workspace_sent_to_review using workspace_id
 */

import { pushEvent } from './gtm';

/**
 * Track when user submits workspace form (before auth)
 * This tracks attempts - can happen multiple times before user authenticates
 */
export function trackWorkspaceFormSubmitted(categoryId?: string): void {
  pushEvent({
    event: 'workspace_form_submitted',
    category_id: categoryId,
  });
}

/**
 * Track when workspace is successfully created from draft (after auth)
 * From here on, we use workspace_id to track the conversion funnel
 */
export function trackWorkspaceCreated(workspaceId: string, categoryId?: string): void {
  pushEvent({
    event: 'workspace_created',
    workspace_id: workspaceId,
    category_id: categoryId,
  });
}

/**
 * MAIN CONVERSION EVENT: Track when workspace is sent to review
 * This is the goal - user completed the entire funnel
 */
export function trackWorkspaceSentToReview(workspaceId: string, data: {
  categoryId: string;
  imagesCount: number;
}): void {
  pushEvent({
    event: 'workspace_conversion',
    workspace_id: workspaceId,
    category_id: data.categoryId,
    images_count: data.imagesCount,
    value: 1,
  });
}
